const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/communities/$communityId/events/$eventId/")({
  validateSearch: zodValidator(z.object({
    checkIn: z.boolean().optional()
  })),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});